function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "drag_indicator-black-18dp",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M6.5,13A1.5,1.5,0,1,1,8,11.5,1.5,1.5,0,0,1,6.5,13Zm-5,0A1.5,1.5,0,1,1,3,11.5,1.5,1.5,0,0,1,1.5,13Zm5-5A1.5,1.5,0,1,1,8,6.5,1.5,1.5,0,0,1,6.5,8Zm-5,0A1.5,1.5,0,1,1,3,6.5,1.5,1.5,0,0,1,1.5,8Zm5-5A1.5,1.5,0,1,1,8,1.5,1.5,1.5,0,0,1,6.5,3Zm-5,0A1.5,1.5,0,1,1,3,1.5,1.5,1.5,0,0,1,1.5,3Z",
  transform: "translate(5 2)",
  fill: "#878787"
}));

var SvgIconDragIndicator = function SvgIconDragIndicator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Icon_drag_indicator",
    "data-name": "Icon/Icon drag_indicator",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDragIndicator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-drag-indicator.371df058.svg";
export { ForwardRef as ReactComponent };